import Vue from 'vue';

export class TimetablePhase {
    id: number;
    name: string;
    color: string;

    klass: object = TimetablePhase;

    constructor(id: number, name: string) {
      this.id = id;
      this.name = name;
    }

}

export default TimetablePhase;
